import {useCustomSnackbar} from "../../useCustomSnackbar";
import {useQuery} from "@tanstack/react-query";
import {shovelFloorControlService} from "../../../api/bhp/geomeasurement/ShovelFloorControl/shovelFloorControlService";

export const useReadShovelFloorControl = (id: string) => {
    const {enqueueError} = useCustomSnackbar()

    return useQuery({
        queryKey: [`shovelFloorControlItem ${id}`], queryFn: async () => {
            try {
                const stockDumpModel = await shovelFloorControlService.read(id)
                return Promise.resolve(stockDumpModel)
            } catch (e) {
                enqueueError(e)
            }
        },
    })
}

